module.exports = __webpack_public_path__ + "img/banner03.306fbb19.jpg";